import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVoiceMid: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"voice-mid, wave"} maskId="square-filled-radius-0-stroke-1-IconVoiceMid"><path d="M8 19H7V5H8V19Z" fill="currentColor"/><path d="M17 17H16V7H17V17Z" fill="currentColor"/><path d="M12.5 15H11.5V9H12.5V15Z" fill="currentColor"/><path d="M4 14H3V10H4V14Z" fill="currentColor"/><path d="M21 14H20V10H21V14Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconVoiceMid;
